import React, { memo, type ReactNode } from 'react'
import styled from '@emotion/styled'
import type { PaymentMethod } from '@mobi/api-types'
import { spacing } from '@mobi/component-library/Foundations'
import { makeAccessibleName } from '@mobi/component-library/Areas/Deposit/Buttons/BankCard/helpers'
import { nameCardIssuerMap } from '../helpers'
import { BankCardName } from './BankCardName'

type CardProps = Pick<PaymentMethod, 'lastFour' | 'formattedExpiryDate' | 'issuerName'> & {
  isSelected: boolean
  alertLabel?: ReactNode
}

type Props = CardProps & {
  icon: ReactNode
}

export const BankCardDisplay = memo<Props>(
  ({ lastFour, formattedExpiryDate, alertLabel, issuerName, icon }) => {
    return (
      <BankCardDisplayStyled
        aria-label={makeAccessibleName(nameCardIssuerMap[issuerName], lastFour)}
      >
        {icon ?? <span />}

        <BankCardName issuerName={issuerName} lastFour={lastFour} />

        {alertLabel ?? <span style={{ textAlign: 'right' }}>{formattedExpiryDate}</span>}
      </BankCardDisplayStyled>
    )
  }
)
BankCardDisplay.displayName = 'BankCardDisplay'

const BankCardDisplayStyled = styled.span({
  alignItems: 'center',
  display: 'inline-grid',
  gap: spacing.smx2,
  gridTemplateColumns: 'minmax(0, max-content) 3.2rem 1fr minmax(0, min-content)',
  textAlign: 'left',
  width: '100%',
})
